<template>
  <div class="field-address" v-if="isReady">
    <div class="field-row-wrapper" data-row-span="4">
      <Field
        :ref="InputAddress1.Id"
        :data="InputAddress1"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
        @field:suggestion="evtSuggestion"
      />
    </div>
    <div class="field-row-wrapper" data-row-span="4">
      <Field
        :ref="InputAddress2.Id"
        :data="InputAddress2"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
      />
      <Field
        :ref="InputCity.Id"
        :data="InputCity"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
      />
    </div>
    <div class="field-row-wrapper" data-row-span="4">
      <Field
        :ref="InputState.Id"
        :data="InputState"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
      />
      <Field
        :ref="InputZip.Id"
        :data="InputZip"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
      />
    </div>
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'
import axios from 'axios'

export default {
  name: 'FieldAddress',
  components: {},
  props: {
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String
  },
  data: () => {
    return {
      PreApproveMe,
      isReady: false,
      InputAddress1: false,
      InputAddress2: false,
      InputCity: false,
      InputState: false,
      InputZip: false,
      geolocation: {
        lat: false,
        lon: false
      },
      suggestBuffer: false,
      allowSuggestions: true
    }
  },
  methods: {
    evtValid: function($event) {
      this.$emit('field:isvalid', $event)
      if ($event.Id == this.data.Id + '__address_1') {
        $event.Id = this.data.Id
        this.$emit('field:isvalid', $event)
      }
    },
    evtFocused: function($event) {
      this.$emit('field:isfocused', $event)
      if ($event.Id == this.data.Id + '__address_1') {
        $event.Id = this.data.Id
        this.$emit('field:isfocused', $event)
      }
    },
    evtValue: function($event) {
      this.$emit('field:value', $event)
      if ($event.Id == this.data.Id + '__address_1') {
        $event.Id = this.data.Id
        this.$emit('field:value', $event)
      }
    },
    evtChange: function($event) {
      this.$emit('field:change', $event)
      if ($event.Id == this.data.Id + '__address_1') {
        $event.Id = this.data.Id
        this.$emit('field:change', $event)
        this.suggestAddress($event.Value)
      }
    },
    evtDelete: function($event) {
      this.$emit('field:delete', $event)
      if ($event.Id == this.data.Id + '__address_1') {
        $event.Id = this.data.Id
        this.$emit('field:delete', $event)
        this.suggestAddress($event.Value)
      }
    },
    evtSuggestion: function($event) {
      // AC: Do not ever do this, the below is extremely bad practice but fixing it properly is likely to require a pretty deep system rebuild
      // We need to commit to that rebuild at some point though, because like I said, never ever do this
      this.$refs[this.InputAddress1.Id].$refs['field'].$refs[
        'input'
      ].inputVal =
        $event.Value.address.streetNumber +
        ' ' +
        $event.Value.address.streetName
      this.$refs[this.InputCity.Id].$refs['field'].$refs[
        'input'
      ].inputVal = $event.Value.address.municipality
      this.$refs[this.InputState.Id].$refs['field'].$refs[
        'input'
      ].inputVal = $event.Value.address.countrySubdivision
      this.$refs[this.InputZip.Id].$refs['field'].$refs[
        'input'
      ].inputVal = $event.Value.address.postalCode
    },
    geolocate: function() {
      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.geolocation.lat = position.coords.latitude
            this.geolocation.lon = position.coords.longitude
          }
        )
      }
    },
    getSuggestions: function(query) {
      return new Promise((resolve, reject) => {
        let newSuggestions = []
        if (query && query.length > 1) {
          query = encodeURI(query)
          const AzureMapsKEY = 'WpXokGR8FrhnFHVrnHB_ZjmO0AOxrzAc5ujFGlfptYY'
          let AzureMapsURL =
            'https://atlas.microsoft.com/search/address/json?subscription-key=' +
            AzureMapsKEY +
            '&api-version=1.0&query=' +
            query +
            '&typeahead=true&countrySet=US'
          if (this.geolocation.lat !== false) {
            AzureMapsURL =
              AzureMapsURL +
              '&lat=' +
              this.geolocation.lat +
              '&lon=' +
              this.geolocation.lon
          }
          axios
            .get(AzureMapsURL)
            .then(result => {
              if (result.status === 200) {
                if (
                  result.data &&
                  result.data.results &&
                  result.data.results.length > 0
                ) {
                  for (let i = 0; i < result.data.results.length; i++) {
                    const currRecc = result.data.results[i]
                    if (
                      (currRecc.type == 'Point Address' ||
                        currRecc.type == 'Address Range') &&
                      newSuggestions.length <= 5
                    ) {
                      newSuggestions.push({
                        Text: currRecc.address.freeformAddress,
                        Value: currRecc
                      })
                    }
                  }
                }
                resolve(newSuggestions)
              } else {
                reject('Invalid status code: ' + result.status)
              }
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    suggestAddress: function(query) {
      if (this.suggestBuffer !== false) clearTimeout(this.suggestBuffer)
      if ((query || '').length > 1 && query.includes(' ') && this.allowSuggestions) {
        this.suggestBuffer = setTimeout(() => {
          this.getSuggestions(query).then(response => {
            this.InputAddress1.Suggestions = response
          })
        }, 650)
      } else {
        this.InputAddress1.Suggestions = []
      }
    }
  },
  mounted: function() {
    this.InputAddress1 = {
      Id: this.data.Id + '__address_1',
      Type: 13,
      Text: 'Street Address',
      Required: this.data.Required,
      FieldSpan: 4,
      Suggestions: [],
      Value:
        this.data.Value && typeof this.data.Value.Street1 !== 'undefined'
          ? this.data.Value.Street1
          : null
    }
    this.InputAddress2 = {
      Id: this.data.Id + '__address_2',
      Type: 13,
      Text: 'Apt / Ste / #',
      Required: false,
      FieldSpan: 2,
      Value:
        this.data.Value && typeof this.data.Value.Street2 !== 'undefined'
          ? this.data.Value.Street2
          : null
    }
    this.InputCity = {
      Id: this.data.Id + '__city',
      Type: 13,
      Text: 'City',
      Required: this.data.Required,
      FieldSpan: 2,
      Value:
        this.data.Value && typeof this.data.Value.City !== 'undefined'
          ? this.data.Value.City
          : null
    }
    this.InputState = {
      Id: this.data.Id + '__state',
      Type: 2,
      Text: 'State',
      Required: this.data.Required,
      FieldSpan: 2,
      Options: PreApproveMe.listStates,
      Value:
        this.data.Value && typeof this.data.Value.State !== 'undefined'
          ? this.data.Value.State
          : null
    }
    this.InputZip = {
      Id: this.data.Id + '__zip',
      Type: 5,
      Text: 'Zip Code',
      Required: this.data.Required,
      FieldSpan: 2,
      MinValue: 1000,
      MaxValue: 99999,
      Value:
        this.data.Value && typeof this.data.Value.Zip !== 'undefined'
          ? this.data.Value.Zip
          : null
    }
    this.isReady = true
    this.geolocate()
  }
}
</script>

<style scoped lang="scss">
.field-address {
}
</style>
